import { gql, useMutation } from '@apollo/client';
import {
  RecordCheckoutConversionMutation,
  RecordCheckoutConversionMutationVariables,
} from '../../graphql/types';

const RECORD_CHECKOUT_CONVERSION = gql`
  mutation RecordCheckoutConversion(
    $checkoutSessionId: String!
    $gclid: String
    $gbraid: String
    $wbraid: String
    $fbclid: String
    $marketingAnonymousId: String
  ) {
    recordCheckoutConversion(
      checkoutSessionId: $checkoutSessionId
      gclid: $gclid
      gbraid: $gbraid
      wbraid: $wbraid
      fbclid: $fbclid
      marketingAnonymousId: $marketingAnonymousId
    )
  }
`;

export const useRecordCheckoutConversion = () =>
  useMutation<RecordCheckoutConversionMutation, RecordCheckoutConversionMutationVariables>(
    RECORD_CHECKOUT_CONVERSION,
  );
